<ng-container [formGroup]="formGroup">
  <mat-form-field appearance="outline">
    <mat-label i18n>User Field</mat-label>
    <mat-select id="user-field" formControlName="userField">
      @for (option of discreteUserFieldNamesWithCategoryNames; track option) {
        <mat-option [value]="option.id">
          {{ option.name }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>{{ getUserFieldName() }}</mat-label>
    <mat-select id="user-field-category" multiple formControlName="userFieldCategories">
      @for (option of getUserFieldCategories(); track option) {
        <mat-option [value]="option.id" [title]="option.name">
          {{ option.name }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</ng-container>
